<template>
  <section class="mepandes mb-5" v-if="mepandes.length">
    <div
      class="heading text-center mar-bottom-40"
      data-aos="fade-up"
    >
      <h2 class="title text-uppercase">Mepandes</h2>
      <div class="sub-title">Potong Gigi</div>
    </div>

    <ul class="text-center persons">
      <li
        class="person font-secondary text-teal-dark"
        data-aos="fade-up"
        v-for="person in mepandes"
        :key="person"
      >
        <span>{{ person }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: ["mepandes"],
};
</script>
